import './App.css';
import Adminmeeting from './Components/Adminmeeing';
import Landing from './Components/Landing';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';     
function App() {
  return (
    <div className="App">
      <Router>
        <Routes>
          <Route index path="/" element={<Landing />} />
          <Route index path="/schedulemeeting" element={<Adminmeeting />} />
       
          {/* <Route path="/about" element={<About />} /> */}
        </Routes>
      </Router>

    </div>
  );
}

// export default App;


// import React from 'react';
// import Landing from './Components/Landing';
// function App() {


//   return (
//     <div className="App">
//       <Landing />
//     </div>
//   );
// }

export default App;
